import { CircleHelp } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';

type InfoHintProps = {
  title: string;
  description: string;
};

export function InfoHint({ title, description }: InfoHintProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label={`What is ${title}?`}
          className="inline-flex h-5 w-5 items-center justify-center rounded-full text-neutral-500 hover:text-neutral-800 dark:text-neutral-400 dark:hover:text-neutral-100"
        >
          <CircleHelp className="h-4 w-4" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-80 text-xs leading-relaxed">
        <p className="font-semibold text-neutral-900 dark:text-neutral-100">{title}</p>
        <p className="mt-1 text-neutral-600 dark:text-neutral-300">{description}</p>
      </PopoverContent>
    </Popover>
  );
}

